module.exports = __webpack_public_path__ + "img/Advanced Search - Green - Selected.eae9b9c5.png";